import React, {Component} from "react";
import PropTypes from 'prop-types';
import {Button, Alert} from 'reactstrap';

export default class ValidationAlert extends Component {

  static propTypes = {
    onClose: PropTypes.func.isRequired,
    messages: PropTypes.array.isRequired
  };

  render() {
    return (
      <div id="alert-background" style={{zIndex: 15}}>
        <Alert className="alertGrid" isOpen={true}
               toggle={this.props.onClose}>
          <h4>Oh snap! You got an error!</h4>
          {this.props.messages.map((msg, idx) => {
            return <p key={idx}>{msg}</p>
          })}
          <p>
            <Button id="hide-alert-btn" color="secondary" onClick={this.props.onClose}>Hide</Button>
          </p>
        </Alert>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Alerts/ValidationAlert.js